import type { RulesUrlState } from './rulesUrl'

export interface RulesCatalog {
  code: string
  total: number
  /** Долгота, широта, зум — начальный вид карты каталога. */
  home: [number, number, number] | null
}

/** Смена каталога. Сбрасывается всё, что принадлежит ПРЕЖНЕМУ документу:
 *  раздел «II.VIII», вид «минтай», орудие и выбранная норма — слова и коды
 *  одного приказа, в другом их нет, и отбор молча вернул бы пустой список.
 *  Точка сбрасывается тоже: она лежала в воде прежнего каталога, и сервер
 *  (`region_for_request`) вернул бы его обратно. Тип рыболовства, длина
 *  судна, дата и «только действующие» — свойства судна и дня, они остаются. */
export function switchCatalog(code: string): Partial<RulesUrlState> {
  return {
    region: code, section: null, kind: null, species: null, gear: null,
    selected: null, q: '', at: null, radius: null,
  }
}

export function homeOf(catalogs: RulesCatalog[] | undefined, code: string) {
  const h = catalogs?.find(c => c.code === code)?.home
  return h ? { center: [h[0], h[1]] as [number, number], zoom: h[2] } : null
}
